import React from 'react';

import { SiteConfigManager } from '@atlas/core';

import Copyright from './Copyright';

const ShortFooter = ({ isAlwaysRendered = false }) => {
  const enableFooterForAllPages = SiteConfigManager.getConfig(
    'config.config.general.enableFooterForAllPages',
  );

  if (!enableFooterForAllPages && !isAlwaysRendered) return null;

  return (
    <div className="menu-footer-container footer-align-bottom">
      <Copyright />
    </div>
  );
};

export default ShortFooter;
